import React, { useEffect } from 'react';
import * as PropTypes from 'prop-types';
import cn from 'classnames';
import omitBy from 'lodash/omitBy';
import isEmpty from 'lodash/isEmpty';

import { usePatientInfoForm } from '../utils/usePatientInfoFormState';
import { PatientInfoForm } from './PatientInfoForm';
import Button from '../../Button';
import { enhance } from './enhance';

const DashboardPatientInfo = ({
  patientValidationError: serverError,
  validatePatientInfo,
  clearRecordErrors,
  formatMessage,
  commonErrors,
  pending,
  patient,
}) => {
  const {
    handleFormChange,
    validateErrors,
    clearErrors,
    formState,
    isValid,
  } = usePatientInfoForm(patient, commonErrors);

  useEffect(() => {
    clearErrors();
    clearRecordErrors();
  }, [formState]);

  const handleSubmit = e => {
    e.preventDefault();
    validatePatientInfo({
      data: omitBy(formState, isEmpty),
    });
  };

  const disabled =
    !isValid || Boolean(serverError) || Boolean(commonErrors) || pending;

  return (
    <div styleName="section">
      <div styleName={cn('content', { disabled: pending })}>
        <form onSubmit={handleSubmit}>
          <label styleName="form--label">
            {formatMessage({ id: 'dashboard.record.patientInfo' })}
          </label>

          <PatientInfoForm
            {...formState}
            formatMessage={formatMessage}
            validateErrors={validateErrors}
            onChange={handleFormChange}
            serverError={serverError}
          />

          <div styleName="btn-block">
            <Button
              className="mr3"
              type="submit"
              raised
              color="primary"
              disabled={disabled}
            >
              {formatMessage({ id: 'common.next' })}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

DashboardPatientInfo.propTypes = {
  validatePatientInfo: PropTypes.func,
  formatMessage: PropTypes.func,
  pending: PropTypes.bool,
  patientValidationError: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.bool,
  ]),
  commonErrors: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  patient: PropTypes.object,
  clearRecordErrors: PropTypes.func,
};

export default enhance(DashboardPatientInfo);



// WEBPACK FOOTER //
// ./src/components/DashboardRecord/DashboardPatientInfo/index.jsx